
export const STAGE_ENUM = {
    LOCKED: "LOCKED",
    INIT: "INIT",
    GENERATE: "GENERATE",
    GENERATING: "GENERATING",
    GENERATED: "GENERATED",
    CHANGED: "CHANGED",
    CHANGED_CONFIRM: "CHANGED_CONFIRM",
    SYMMETRICAL: "SYMMETRICAL",
    DONE: "DONE",
};

export const conditionMapping = ["?", "F", "FL", "L", "BL", "B", "BR", "R", "FR", "U", "D"];